<button
  type="button"
  class="back-button"
  [attr.aria-label]="label()"
  (click)="onClick()"
>
  <img
    src="assets/icons/ico_arrow_left.svg"
    width="16"
    height="16"
    alt=""
    aria-hidden="true"
    class="back-button__icon"
  />
  <span class="back-button__label">{{ label() }}</span>
</button>
